<template>
  <div class="input-group mb-3">
    <div class="input-group-prepend">
      <span class="input-group-text">File</span>
    </div>
    <input type="text" class="form-control" @input="updateFile"  :value="file" placeholder="File Id or File url">
  </div>
</template>


<script>
export default {
  name: 'File',
  props: {
    file: String
  },
  methods: {
    updateFile: function(event){
      this.$emit('updateFile', event.target.value);
    }
  },
}
</script>
